<template>
  <div class="d-flex flex-column justify-content-between vh-100 w-100">
    <main-hero :hero-title="$t('Reset Password')" />
    <div class="row">
      <div class="col">
        <b-row>
          <b-col class="col-12">
            <b-card class="bg-white overflow-hidden col-lg-6">
              <spinner v-if="busy" />
              <validation-observer v-else-if="isValidToken === true" ref="validation">
                <form @submit.prevent="onSubmit">
                  <validation-provider v-slot="{validated, errors, dirty, valid, invalid}" rules="required|valid-password" vid="password">
                    <b-form-group
                      id="new-password-fieldset"
                      :label="$t('Enter your new password')"
                      label-for="new-password"
                    >
                      <b-form-input id="new-password" v-model="password" type="password" :state="(dirty || validated) ? (valid ? null : false) : null" trim />
                      <password v-model="password" :strength-meter-only="true" />
                      <b-form-invalid-feedback :state="invalid" :force-show="invalid">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider v-slot="{validated, errors, dirty, valid, invalid}" rules="required|confirmed:password">
                    <b-form-group
                      id="confirm-password-fieldset"
                      :label="$t('Confirm your password')"
                      label-for="confirm-password"
                    >
                      <b-form-input id="confirm-password" v-model="confirmPassword" type="password" :state="(dirty || validated) ? (valid ? null : false) : null" trim />
                      <b-form-invalid-feedback :state="invalid" :force-show="invalid">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  <b-button variant="primary" type="submit">
                    {{ $t('Reset my password') }}
                  </b-button>
                </form>
              </validation-observer>
              <b-alert v-else :show="true" variant="danger">
                {{ $t('This link is invalid') }}
              </b-alert>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import MainHero from "@/components/section/MainHero"
import AppFooter from "@/components/footer/AppFooter"
import Notification from '@/imports/mixins/notification';
import Spinner from '@/components/animation/Spinner';
import {ValidationProvider, ValidationObserver} from 'vee-validate';

export default {
  name: "ResetPassword",
  components: {
    ValidationProvider,
    ValidationObserver,
    Spinner,
    Password: () => import('vue-password-strength-meter'),
    MainHero,
    AppFooter
  },
  mixins: [Notification],
  data() {
    return {
      password: '',
      confirmPassword: '',
      isValidToken: null,
      busy: true,
    }
  },
  methods: {
    onSubmit() {
      this.$refs.validation.validate().then((success) => {
        if (!success) {
          return;
        }
        this.busy = true;
        this.$api.auth.resetPassword(this.$route.query.token, this.$route.query.email, this.password, this.confirmPassword)
          .then((response) => {
            if (response.data.data && response.data.data.errors) {
              this.notify(this.$bvToast, response.data.data.errors.join(', '), null, 'danger');
              this.busy = false;
            } else {
              if (this.$store.state.USER_STATE === true) {
                this.$store.dispatch('logOut');
              } else {
                this.$router.push({name: 'log-in', params:{email: this.$route.query.email}});
              }
            }
          }).catch(() => this.busy = false);
      });
    }
  },
  created() {
    if (this.$route.query.token === undefined || this.$route.query.email === undefined) {
      this.isValidToken = false;
      this.busy = false;
    } else {
      this.$api.auth.checkPasswordResetToken(this.$route.query.token, this.$route.query.email)
        .then((response) => this.isValidToken = (response.data.data === undefined))
        .catch(() => this.isValidToken = false)
        .finally(() => this.busy = false);
    }
  },
}
</script>

<style scoped lang="scss">
  .card {
    box-shadow: 0 0 1.875rem rgba(0,0,0,.16);
    max-width: 576px;
    margin: -85px auto 0;
    border-radius: 48px;

    @include media-breakpoint-down(sm) {
      padding: 100px 25px 100px;
    }

    @include media-breakpoint-up(sm) {
      padding: 100px 60px 100px;
    }
  }
</style>
